/**
 * Escapes a value for CSV format
 * @param {any} v - Value to escape
 * @returns {string} Escaped CSV value
 */
export function toCsvValue(v) {
  if (v == null) return "";
  const s = String(v);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * Creates a CSV string from rows and headers
 * @param {Object} params
 * @param {Array<Object>} params.rows - Array of row objects
 * @param {Array<{key: string, label: string}>} params.headers - Array of header definitions
 * @returns {string} CSV string with BOM for Excel compatibility
 */
export function makeCsv({ rows, headers }) {
  const head = headers.map((h) => toCsvValue(h.label)).join(",");
  const body = rows.map((r) =>
    headers.map((h) => toCsvValue(r[h.key])).join(",")
  );
  return "\uFEFF" + [head, ...body].join("\n");
}

/**
 * Downloads a CSV string as a file
 * @param {Object} params
 * @param {string} params.csv - CSV string content
 * @param {string} params.filename - Filename for the download
 */
export function downloadCsv({ csv, filename }) {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

